/* eslint-disable react/jsx-no-bind */
import React, { useState } from 'react';
import { Layout, Table, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import PageTitle from '../../lib/page-title';
import useDevices from './use-devices';
import { useStore } from '../../../store';
import PrimaryButton from '../../lib/primary-button';
import FilterSelect from '../../lib/filter-select';
import Modal from '../../lib/modal';
import DeleteModal from '../../lib/delete-modal';
import { CREATE_DEVICE_PATH } from '../../routing/paths.constants';
import QrModal from '../../lib/qrModal';
import PermissionProvider from '../../providers/permissionProvider';

const Devices = (): JSX.Element => {
  const {
    onSearch,
    filteredDevices,
    columns,
    filters,
    apiKey,
    isLoading,
    keyModalVisible,
    onCloseKeyPopup,
    onCloseOtsPopup,
    onDeleteDevice,
    onCloseDeleteModal,
    otsModalVisible,
    deleteModalVisible,
    otsqr,
    otsNumber,
  } = useDevices();

  const { devices } = useStore();
  const { push } = useHistory();
  const [currentFilter, setCurrentFilter] = useState<string>('');
  const [searchValue, setSearchValue] = useState<string>('');
  // const [selectedRowKeys, setSelectedRowKeys] = useState<ReactText[]>([]);

  const handleChange = (e: string) => {
    setCurrentFilter(e);
    onSearch(searchValue, e);
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
    onSearch(e.target.value, currentFilter);
  };
  return (
    <Layout className="main-container">
      <PermissionProvider pageId="devices">
        {deleteModalVisible && (
          <DeleteModal
            text="Device"
            modalVisible={deleteModalVisible}
            onConfirm={onDeleteDevice}
            onCancel={() => onCloseDeleteModal()}
          />
        )}
        {keyModalVisible && (
          <Modal
            value={apiKey}
            visible={keyModalVisible}
            handler={() => onCloseKeyPopup()}
            isLoading={isLoading}
            width={400}
            height={400}
          />
        )}
        {otsModalVisible && (
          <QrModal
            value={otsqr}
            qrValue={otsNumber}
            visible={otsModalVisible}
            handler={() => onCloseOtsPopup()}
            isLoading={isLoading}
            initialHeight={undefined}
          />
        )}
        <PageTitle title="Devices">
          <PrimaryButton
            title="New Device"
            onClick={() => {
              push(CREATE_DEVICE_PATH);
            }}
          />
        </PageTitle>
        <div className="table__wrapper">
          <div className="filter__wrapper">
            <FilterSelect
              currentFilter={currentFilter}
              onChange={(e) => handleChange(e)}
              data={filters}
            />
            <Input
              className="search"
              placeholder="Keyword"
              onChange={onChange}
              suffix={<SearchOutlined style={{ color: '#D0D3D9' }} />}
            />
          </div>
          <Table
            className="table"
            style={{ height: 'auto' }}
            bordered={false}
            dataSource={filteredDevices}
            pagination={{ position: ['bottomCenter'], hideOnSinglePage: true }}
            loading={devices.loading}
            rowKey={(record) => record.id as number}
            columns={columns}
          />
        </div>
      </PermissionProvider>
    </Layout>
  );
};

Devices.displayName = 'Devices';

export default Devices;
